import * as React from 'react'
import { withRouter } from 'react-router'
import qs from 'qs'
import _ from 'lodash'

// components
import CatalogLayout from '../../../../components/ui/CatalogLayout/CatalogLayout'
import Icon from '../../../../components/ui/Icon/Icon'
import EConciergeModal from '../../../../components/home/EConciergeModal/EConciergeModal'
import SearchMallModal from '../../../../components/home/SearchMallModal/SearchMallModal'
import StoreModal from '../../../../components/home/StoreModal/StoreModal'
import {
  CardContent,
  LogoContainer,
  LogoFiller,
  Logo,
  Title,
  StyledCatalogList,
  ErrorCard,
  ZingIconComponent,
  StyledLink,
  StyledShopDineCard,
  FormContainer,
  SelectMallButton,
  InputContainer,
  StyledTextInput,
  Content,
  BannerContent,
  BannerDescription,
  RewardsCatalogDescription,
  RewardsCatalogTitle,
  Heading,
  StyledBanner,
} from './MainView.style'

// data
import { DEFAULT_CATEGORY } from '../../../../services/data/rewardsCategory.json'
import { VOUCHERS } from '../../../../services/data/profilePages.json'
import {
  ECONCIERGE_SHOP,
  ECONCIERGE_DINE,
  ECONCIERGE_UNWIND,
} from '../../../../services/data/errorNames.json'

// analytics
import {
  setGAPageView,
  setGAEvent,
} from '../../../../services/analytics/google-analytics'

// controllers
import { doGetAllMalls } from '../../../../controllers/Malls'
import {
  doGetAllRewards,
  doGetRewardsByMerchant,
} from '../../../../controllers/Offers'
import {
  doGetContentTypeEConcierge,
  doGetAllExploreDine,
  doGetAllExploreShops,
  doGetAllExploreUnwind,
  doGetDashboardStore,
} from '../../../../controllers/Explore'

const ECONCIERGE = doGetContentTypeEConcierge()

class MainView extends React.Component {
  debouncedSearch = _.debounce(search => {
    setGAEvent('rewards_merchant', 'search_merchant_rewards', search)
  }, 250)

  constructor(props) {
    super(props)

    const { location } = props.history
    const { match } = props
    const { mallSlug, viewType } = match.params

    const initialSearch = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    })

    this.state = {
      apiKey: '',
      merchants: [],
      searchQuery: initialSearch.q || '',
      searched: [],
      selectedCatalog: {
        id: DEFAULT_CATEGORY,
      },
      modalToggle: false,
      modalTitle: '',
      searchMallModalState: false,
      searchModalState: false,
      malls: [],
      mallList: [],
      prevSelectedMall: null,
      openSelectMall: false,
      showMerchantModal: false,
      merchantModalData: [],
    }

    switch (viewType) {
      case 'shop':
        this.getShopMerchants(mallSlug)
        break
      case 'dine':
        this.getDineMerchants(mallSlug)
        break
      case 'unwind':
        this.getUnwindMerchants(mallSlug)
        break

      default:
        break
    }

    doGetAllMalls({
      onSuccess: ({ data }) => {
        this.setState({
          malls: data,
          mallList: data.map(mall => ({
            name: mall.name,
            value: mall.slugName,
          })),
        })
      },
    })
  }

  componentWillMount() {
    this.retrieveInitialData()
  }

  componentDidMount() {
    const { location } = this.props
    setGAPageView(location.pathname)
  }

  componentDidUpdate(prevProps) {
    const { match, location } = this.props
    const { viewType, viewId, mallSlug } = match.params
    const {
      viewType: prevViewType,
      viewId: prevViewId,
      mallSlug: prevMallSlug,
    } = prevProps.match.params

    if (mallSlug !== prevMallSlug) {
      switch (viewType) {
        case 'shop':
          // typeLabel = 'All Merchants: Shop'
          this.getShopMerchants(mallSlug)
          break
        case 'dine':
          // typeLabel = 'All Merchants: Dine'
          this.getDineMerchants(mallSlug)
          break
        case 'unwind':
          // typeLabel = 'All Merchants: Unwind'
          this.getUnwindMerchants(mallSlug)
          break
        default:
          break
      }
    }

    if (viewType !== prevViewType || viewId !== prevViewId) {
      this.displayModal()
    }

    if (location.pathname !== prevProps.location.pathname) {
      setGAPageView(location.pathname)
    }
  }

  onGetSuccess = (pageLoadStart, event) => ({ data }) => {
    this.setState({
      merchants: data,
    })
    setGAEvent('page', 'loading_duration', event, Date.now() - pageLoadStart)
  }

  onGetError = errorName => error => {
    const { setError } = this.props
    setError({
      name: errorName,
      error: error.message,
    })
  }
  getShopMerchants = (mallSlugName = null) => {
    const { selectedMallSlug, preferenceIds } = this.props

    const pageLoadStart = Date.now()

    doGetAllExploreShops({
      preferenceIds,
      mallSlug: mallSlugName || selectedMallSlug,
      collectionType: ECONCIERGE,
      onSuccess: this.onGetSuccess(pageLoadStart, 'econcierge_shop'),
      onError: this.onGetError(ECONCIERGE_SHOP),
    })
  }

  getDineMerchants = (mallSlugName = null) => {
    const { selectedMallSlug, preferenceIds } = this.props

    const pageLoadStart = Date.now()

    doGetAllExploreDine({
      preferenceIds,
      mallSlug: mallSlugName || selectedMallSlug,
      collectionType: ECONCIERGE,
      onSuccess: this.onGetSuccess(pageLoadStart, 'econcierge_dine'),
      onError: this.onGetError(ECONCIERGE_DINE),
    })
  }

  getUnwindMerchants = (mallSlugName = null) => {
    const { selectedMallSlug, preferenceIds } = this.props

    const pageLoadStart = Date.now()

    doGetAllExploreUnwind({
      preferenceIds,
      mallSlug: mallSlugName || selectedMallSlug,
      collectionType: ECONCIERGE,
      onSuccess: this.onGetSuccess(pageLoadStart, 'econcierge_unwind'),
      onError: this.onGetError(ECONCIERGE_UNWIND),
    })
  }

  onCategoriesChange = e => {
    const catalogId = e.target.value
    const { setRewards, accessToken } = this.props

    doGetAllRewards({ accessToken, setRewards })('', catalogId)
  }

  retrieveInitialData = async () => {
    const { waitRenderServer, renderServer } = this.props

    waitRenderServer(true)

    await this.displayModal()

    renderServer()
  }

  displayModal = async () => {
    const {
      match,
      setRewardModalData,
      setRewardModalStatus,
      accessToken,
      // advanceAccount,
    } = this.props
    const { viewId } = match.params

    if (viewId) {
      setRewardModalStatus(1)
      try {
        await doGetRewardsByMerchant({ accessToken, setRewardModalData })(
          viewId,
        )
        setRewardModalStatus(0)
      } catch (e) {
        setRewardModalStatus(4)
      }
    } else {
      setRewardModalData({})
      setRewardModalStatus(null)

      setGAEvent('page', 'page_visit', 'rewards_catalog')
    }
  }

  handleClose = () => {
    const {
      push,
      baseUrl,
      setRewardModalData,
      setRewardModalStatus,
    } = this.props

    if (push) {
      push(`${baseUrl}`)
      setRewardModalData({})
      setRewardModalStatus(null)
    }
  }

  onCatalogChange = catalog => {
    this.setState({
      merchants: [],
    })
    this.getRewardsMerchants(catalog.id)

    setGAEvent('rewards', 'rewards_category', catalog.name)
  }

  onCatalogSearch = e => {
    const { merchants } = this.state

    const searched = merchants.filter(merchant => {
      const merchantName = merchant.name.toLowerCase()
      const searchQuery = e.target.value.toLowerCase()

      return merchantName.includes(searchQuery)
    })

    this.setState({
      searchQuery: e.target.value,
      searched,
    })

    this.debouncedSearch(e.target.value)
  }

  displayMyVouchers = data => {
    const {
      displayProfileModal,
      setProfileModalPage,
      setProfileModalDetailPage,
      accessToken,
    } = this.props

    if (accessToken) {
      displayProfileModal(true)
      setProfileModalPage(VOUCHERS)
      if (data) {
        setProfileModalDetailPage(data)
      }
    }
  }

  handleModal = (state, title = '') => {
    this.setState({
      modalToggle: state,
      modalTitle: title,
    })
  }

  handleShowExploreSearch = e => {
    e.stopPropagation()
    this.setState({
      searchModalState: true,
    })
  }

  searchMallModalToggle = e => {
    this.setState({
      searchMallModalState: false,
    })
  }

  searchModalToggle = e => {
    this.setState({
      searchModalState: false,
    })
  }

  handleSelectMall = e => {
    e.stopPropagation()
    this.setState({
      searchMallModalState: true,
    })
  }

  onChangeMall = async mallSlugName => {
    const {
      push,
      // malls,
      // baseUrl,
      // accessToken,
      // showAddFavorite,
      // disableFavoritePrompt,
      // favoriteMalls,
      setSelectedMallSlug,
      match,
    } = this.props

    const {
      // viewType, viewId,
      mallSlug,
    } = match.params

    if (push) {
      this.setState({
        searchMallModalState: false,
      })

      setSelectedMallSlug(mallSlug)

      this.getShopMerchants(mallSlug)
      this.getDineMerchants(mallSlug)
      this.getUnwindMerchants(mallSlug)
    }
  }

  onCatalogSearch = e => {
    const { merchants } = this.state

    const searched = merchants.filter(merchant => {
      const merchantName = merchant.title.toLowerCase()
      const searchQuery = e.target.value.toLowerCase()

      return merchantName.includes(searchQuery)
    })

    this.setState({
      searchQuery: e.target.value,
      searched,
    })
  }

  handleMerchantModal = storeId => {
    doGetDashboardStore({
      storeId,
      onSuccess: response => {
        this.setState({
          showMerchantModal: true,
          merchantModalData: response.data,
        })
      },
    })
  }

  handleMerchantModalClose = e => {
    this.setState({ showMerchantModal: false })
  }

  render() {
    const {
      history,
      showRewardModal,
      rewardModalData,
      rewardModalStatus,
      advanceAccount,
      accessToken,
      push,
      baseUrl,
      setLoyaltyPoints,
      loyaltyPoints,
      setLoyaltyPointsError,
      loyaltyPointsError,
      errorList,
      selectedMallSlug,
      setFavoriteMalls,
      match,
      deviceLocation,
      favoriteMalls,
      setSelectedMallSlug,
      merchantModalStatus,
      ...theProps
    } = this.props

    const {
      merchants,
      searched,
      searchQuery: searchQueryState,
      // selectedCatalog,
      modalToggle,
      showMerchantModal,
      merchantModalData,
    } = this.state

    const selectedMall = this.state.malls.find(
      mall =>
        mall.slugName === selectedMallSlug && mall.explore && mall.slugName,
    )

    const Banner = () => (
      <StyledBanner>
        <BannerContent>
          <BannerDescription>
            <RewardsCatalogTitle>Econcierge</RewardsCatalogTitle>
            <RewardsCatalogDescription>
              Avoid waiting in lines! Here’s easy access to telephone numbers of
              restaurants for your dine-in reservations, and service merchants
              for your appointments.
            </RewardsCatalogDescription>
          </BannerDescription>
        </BannerContent>
      </StyledBanner>
    )

    return (
      <CatalogLayout
        banner={Banner}
        isEConcierge={true}
        match={match}
        selectedMall={selectedMall}
        accessToken={accessToken}
        {...theProps}
      >
        <Heading>
          <FormContainer>
            <SelectMallButton
              onClick={e => {
                this.handleSelectMall(e)
              }}
            >
              <span>
                {(selectedMall && selectedMall.name) || 'Select Mall'}
              </span>
              <Icon name="caret" />
            </SelectMallButton>
            <InputContainer>
              <StyledTextInput
                variant="search"
                isEconcierge={true}
                whiteOut
                iconColor={'#fff'}
                placeholder="Search Merchant"
                onChange={this.onCatalogSearch}
                value={searchQueryState}
              />
            </InputContainer>
          </FormContainer>
        </Heading>

        <Content>
          {merchants && merchants.length > 0 && (
            <>
              <StyledCatalogList
                dataSource={searchQueryState.length ? searched : merchants}
                loadingComponent={() => (
                  <ErrorCard>
                    <ZingIconComponent />
                  </ErrorCard>
                )}
                renderItem={(item, index) => (
                  <StyledLink
                    onClick={() => {
                      this.handleMerchantModal(item.itemId)
                      setGAEvent('item_clicks', 'view_shop_item', item.title)
                    }}
                  >
                    <StyledShopDineCard cardImageUrl={item.imageUrl}>
                      <CardContent>
                        <LogoContainer cardImageUrl={item.imageUrl}>
                          {item.logoUrl ? (
                            <Logo src={item.logoUrl} />
                          ) : (
                            <LogoFiller>&nbsp;</LogoFiller>
                          )}
                        </LogoContainer>
                        <Title>{item.title}</Title>
                      </CardContent>
                    </StyledShopDineCard>
                  </StyledLink>
                )}
              />
            </>
          )}
        </Content>

        <StoreModal
          malls={this.state.malls}
          show={showMerchantModal}
          data={merchantModalData}
          loading={merchantModalStatus}
          onClose={this.handleMerchantModalClose}
        />

        {modalToggle && (
          <EConciergeModal
            modalTitle={this.state.modalTitle}
            onClose={this.handleModal}
            malls={this.state.malls}
            mallList={this.state.mallList}
            selectedMallSlug={selectedMallSlug}
            setSelectedMallSlug={setSelectedMallSlug}
          />
        )}

        <SearchMallModal
          modalState={this.state.searchMallModalState}
          onClose={this.searchMallModalToggle}
          malls={this.state.malls}
          push={push}
          match={match}
          accessToken={accessToken}
          setFavoriteMalls={setFavoriteMalls}
          baseUrl={baseUrl}
          currentMall={selectedMallSlug}
          onChangeMall={this.onChangeMall}
          selectedMall={selectedMall && selectedMall.id}
          deviceLocation={deviceLocation}
          displayClose={selectedMallSlug !== ''}
          favoriteMalls={favoriteMalls}
          setSelectedMallSlug={setSelectedMallSlug}
        />
      </CatalogLayout>
    )
  }
}

MainView.defaultProps = {
  // TODO: specify default props
}

MainView.propTypes = {
  // TODO: specify prop types
}

export default withRouter(MainView)
